/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Why a survey appears in the "other surveys" section with no setup needed.
 */
export enum SurveySeasonNoActionReason {
    KEPT_PREVIOUS_EDITION = 'keptPreviousEdition',
    NET_NEW = 'netNew',
}
